<template>
  <v-card class="qna-card" outlined>
    <v-card-title class="qna-title">
      <div>
        <div class="text-h6 font-weight-bold">Q&A Analytics</div>
        <div class="caption grey--text text--darken-1">
          Latest questions, responses, and confidence
        </div>
      </div>

      <v-spacer />

      <v-chip small outlined class="font-weight-medium">
        {{ analysisList.length }} Records
      </v-chip>
    </v-card-title>

    <v-divider />

    <v-data-table
      class="qna-table elevation-0"
      fixed-header
      :height="kioskAnalyticsDimension.qnaAnalyticsheight"
      :items="analysisList"
      :headers="analysisHeader"
      item-key="id"
      :items-per-page="-1"
      hide-default-footer
      show-expand
      single-expand
      :expanded.sync="expanded"
      sort-by="timeStamp"
      :sort-desc="true"
    >
      <!-- Question -->
      <template v-slot:[`item.elementContent.question`]="{ item }">
        <div class="text-body-2 font-weight-medium">
          {{ item.elementContent.question | trimLength }}
        </div>
      </template>

      <!-- Answer -->
      <template v-slot:[`item.elementContent.answer`]="{ item }">
        <div class="text-body-2 grey--text text--darken-3">
          {{ item.elementContent.answer | trimLength }}
        </div>
      </template>

      <!-- Confidence -->
      <template v-slot:[`item.elementContent.confidenceScore`]="{ item }">
        <v-chip small dark :color="getColor(item.elementContent)" class="font-weight-bold">
          <v-icon small class="mr-1">mdi-chart-bell-curve</v-icon>
          {{ formatPct(item.elementContent.confidenceScore) }}
        </v-chip>
      </template>

      <!-- Timestamp -->
      <template v-slot:item.timeStamp="{ item }">
        <v-chip x-small outlined class="chip-soft">
          <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
          {{ item.timeStamp | formatDateFromNow }}
        </v-chip>
      </template>

      <!-- Expanded row (full content) -->


      <template v-slot:no-data>
        <div class="pa-10 text-center grey--text">
          <v-icon large class="mb-2">mdi-database-off</v-icon>
          <div>No Q&A analytics found.</div>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "qnaAnalytics",
  data() {
    return {
      expanded: [],
      // ✅ FIX: Use dot-paths that match your slots and your real data shape
      analysisHeader: [
        { text: "Question", align: "start", value: "elementContent.question" },
        { text: "Response", value: "elementContent.answer" },
        { text: "Confidence", align: "center", value: "elementContent.confidenceScore", width: 160 },
        { text: "Time", value: "timeStamp", width: 140 },
        { text: "", value: "data-table-expand", width: 50 },
      ],
    };
  },
  computed: {
    ...mapGetters(["kioskAnalyticsDimension", "getQnAList"]),
    analysisList() {
      // ✅ SAFER: avoid crash when data is undefined initially
      return (this.getQnAList && this.getQnAList.data) ? this.getQnAList.data : [];
    },
  },
  methods: {
    getColor(object) {
      const score = object.confidenceScore != null ? object.confidenceScore * 100 : 0;
      if (score >= 76) return "success";
      if (score >= 60) return "amber darken-2";
      return "error";
    },
    formatPct(val) {
      if (val == null) return "-";
      return `${Math.round(val * 100)}%`;
    },
    formatAbsolute(val) {
      return moment(val).format("lll");
    },
  },
  filters: {
    formatDateFromNow(val) {
      if (!val) return "-";
      return moment(val).fromNow();
    },
    trimLength(val) {
      if (typeof val !== "string") return val;
      if (!val) return val;
      if (val.length <= 100) return val;
      return `${val.substring(0, 80)}...`;
    },
  },
};
</script>

<style scoped>
.qna-card {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
}

.qna-title {
  background: linear-gradient(90deg, rgba(25, 118, 210, 0.10), rgba(25, 118, 210, 0.02));
}

.qna-table >>> tbody tr:hover {
  cursor: pointer;
  background: rgba(25, 118, 210, 0.06) !important;
}

.qna-table >>> .v-data-table__expanded__content {
  background: rgba(25, 118, 210, 0.03);
}

.chip-soft {
  background: rgba(25, 118, 210, 0.06);
}

.expanded-card {
  border-radius: 0;
}
</style>
